import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { defaultNS, namespaces, resources } from './resources'

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'fr'],
  defaultNS,
  ns: namespaces,
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
})

export default i18n
